// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RequirePermission } from "@/components/shared/require-permission";
import { VendorDetail } from "@/features/iam/vendor-detail";
import { PAGE_PERMISSIONS } from "@/lib/auth/page-permissions";

export const Route = createFileRoute("/_authenticated/iam/vendors/$vendorName")({
  validateSearch: z.object({ t: z.string().optional(), f: z.string().optional() }),
  component: VendorDetailPage,
});

function VendorDetailPage() {
  const { vendorName } = Route.useParams();
  const { t: tab, f } = Route.useSearch();
  return (
    <RequirePermission permission={PAGE_PERMISSIONS.iamVendors}>
      <VendorDetail vendorName={vendorName} tab={tab} initialFilters={f} />
    </RequirePermission>
  );
}
